import React, { useEffect, useState } from 'react';
import { hot } from 'react-hot-loader';

const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
const PAGE_SIZE = 10;


function Professors() {
  const [professors, setProfessors] = useState([]);
  const [selectedProfessor, setSelectedProfessor] = useState(null);
  const [professorLessons, setProfessorLessons] = useState([]);
  const [inactiveMonths, setInactiveMonths] = useState([]);
  const [query, setQuery] = useState('');
  const [page, setPage] = useState(1);

  const professorsPath = '/professors/get';
  const professorPath = '/professors/lessons/';

  useEffect(() => {
    fetch(professorsPath)
      .then((r) => r.json())
      .then((data) => setProfessors(data))
      .catch(console.log);
  }, []);

  function selectProfessor(professor) {
    setSelectedProfessor(professor);
    setProfessorLessons([]);
    setInactiveMonths([...months]);
    fetch(`${professorPath}${professor.id}`)
      .then((r) => r.json())
      .then((data) => {
        data.sort((a, b) => months.indexOf(a.month) >= months.indexOf(b.month) ? 1 : -1);
        setProfessorLessons(data);
        let remaining = [...months];
        data.forEach((lesson) => {
          const i = remaining.indexOf(lesson.month);
          if (i > -1) remaining.splice(i, 1);
        });
        setInactiveMonths(remaining);
      })
      .catch(console.log);
  }

  const sorted = [...professors].sort((a, b) => (a.name > b.name ? 1 : -1));
  const filtered = sorted.filter((p) => p.name.toLowerCase().includes(query.toLowerCase()));
  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const pageStart = (page - 1) * PAGE_SIZE;
  const pageRows = filtered.slice(pageStart, pageStart + PAGE_SIZE);

  function handleSearch(e) { setQuery(e.target.value); setPage(1); }

  function pageButtons() {
    const btns = [];
    const show = new Set([1, totalPages, page, page - 1, page + 1].filter(p => p >= 1 && p <= totalPages));
    const sorted = [...show].sort((a, b) => a - b);
    sorted.forEach((p, i) => {
      if (i > 0 && p - sorted[i - 1] > 1) btns.push(<span key={`sep-${p}`} className="prf-page-sep">…</span>);
      btns.push(<button key={p} className={`prf-page-btn${page === p ? ' prf-page-active' : ''}`} onClick={() => setPage(p)}>{p}</button>);
    });
    return btns;
  }

  const totalHours = professorLessons.reduce((s, l) => s + l.duration, 0);
  const lessonsByMonth = {};
  professorLessons.forEach((l) => {
    if (!lessonsByMonth[l.month]) lessonsByMonth[l.month] = [];
    lessonsByMonth[l.month].push(l);
  });

  return (
    <div className="prf-wrap">

        {/* ── LEFT: list ── */}
        <div className="prf-panel">
          <div className="prf-panel-header">
            <div className="prf-panel-title">
              <div className="prf-panel-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              </div>
              <div>
                <h2>Profesores</h2>
                <p>Haz clic para ver detalle</p>
              </div>
            </div>
            <span className="prf-count-badge">{filtered.length}</span>
          </div>

          <div className="prf-search-wrap">
            <div className="prf-search-box">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="rgb(180,130,70)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input type="text" placeholder="Buscar por nombre…" value={query} onChange={handleSearch} />
            </div>
          </div>

          <div style={{ overflowX: 'auto' }}>
            <table className="prf-table">
              <thead><tr><th>Nombre profesor/a</th></tr></thead>
              <tbody>
                {pageRows.map((p) => (
                  <tr key={p.id} className={selectedProfessor && selectedProfessor.id === p.id ? 'prf-selected' : ''} onClick={() => selectProfessor(p)}>
                    <td>{p.name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="prf-pagination">
            <span className="prf-page-info">
              {filtered.length ? `Mostrando ${pageStart + 1}–${Math.min(pageStart + PAGE_SIZE, filtered.length)} de ${filtered.length}` : 'Sin resultados'}
            </span>
            <div className="prf-page-btns">
              <button className="prf-page-btn" disabled={page === 1} onClick={() => setPage(p => p - 1)}>‹</button>
              {pageButtons()}
              <button className="prf-page-btn" disabled={page === totalPages || totalPages === 0} onClick={() => setPage(p => p + 1)}>›</button>
            </div>
          </div>
        </div>

        {/* ── RIGHT: detail ── */}
        <div className="prf-detail">
          {!selectedProfessor ? (
            <div className="prf-empty">
              <svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="rgb(180,130,70)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.35 }}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              <p className="prf-empty-title">Ningún profesor seleccionado</p>
              <p className="prf-empty-sub">Haz clic en una fila para ver el detalle</p>
            </div>
          ) : (
            <>
              <div className="prf-detail-header">
                <div>
                  <p className="prf-detail-name">{selectedProfessor.name}</p>
                  <p className="prf-detail-sub">{selectedProfessor.carreer}</p>
                </div>
                <a className="prf-edit-btn" href={`/professors/${selectedProfessor.id}`}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                  Editar
                </a>
              </div>

              <div className="prf-chips">
                <div className="prf-chip">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.14 13.5a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.05 2.73h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 10.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 18.18z"/></svg>
                  <strong>{selectedProfessor.number}</strong>
                </div>
                <div className="prf-chip">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                  <strong>{selectedProfessor.county}</strong> · {selectedProfessor.address}
                </div>
                {selectedProfessor.link ? (
                  <div className="prf-chip">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
                    <a href={selectedProfessor.link} target="_blank" rel="noreferrer">{selectedProfessor.link}</a>
                  </div>
                ) : null}
              </div>

              <div className="prf-stats">
                <div className="prf-stat">
                  <div className="prf-stat-value">{professorLessons.length}</div>
                  <div className="prf-stat-label">Clases realizadas</div>
                </div>
                <div className="prf-stat">
                  <div className="prf-stat-value">{totalHours}h</div>
                  <div className="prf-stat-label">Horas totales</div>
                </div>
              </div>

              <div className="prf-lessons">
                {months.map((month) => {
                  const lessons = lessonsByMonth[month];
                  const inactive = inactiveMonths.includes(month);
                  return (
                    <div key={month} className={`prf-month-group${inactive ? ' prf-month-inactive' : ''}`}>
                      <div className="prf-month-label">{month}</div>
                      {inactive ? (
                        <div className="prf-no-classes">Sin clases registradas</div>
                      ) : (
                        lessons.map((lesson, i) => (
                          <div key={i} className="prf-lesson-row">
                            <div className="prf-lesson-dot" />
                            <span className="prf-lesson-date">{lesson.date}</span>
                            <span className="prf-lesson-dur">{lesson.duration}h</span>
                            <span className="prf-lesson-subject">{lesson.lecture}</span>
                          </div>
                        ))
                      )}
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>

      </div>
  );
}

export default hot(module)(Professors);
